<template>
  <div class="managers">
    <v-row>
      <v-col cols="12" sm="6">
        <div class="areaTitle">
          <h2>Investment Managers</h2>
          <v-btn
            color="primary"
            depressed
            :disabled="!showFormButtons"
            @click.stop="onAddNewManager"
            class="mr-2"
          >
            <v-icon class="mr-2">mdi-plus</v-icon>
            Add new manager
          </v-btn>
        </div>
        <v-card class="pa-2" outlined tile>
          <v-data-table
            v-model="selectedManager"
            :headers="headers"
            :items="managerList"
            :items-per-page="-1"
            item-key="ManagerId"
            single-select
            dense
            @click:row="selectManager"
          >
          </v-data-table>
        </v-card>
      </v-col>
      <v-divider vertical></v-divider>
      <v-col cols="12" sm="6">
        <v-alert v-if="!isEditMode && !isSelectedManagerExists" outlined dense type="info">
          Please select manager or add the new.
        </v-alert>
        <div v-else class="formContainer">
          <v-form
            v-if="currentManager"
            ref="managerForm"
            v-model="isFormValid"
            lazy-validation
            class="managerForm"
          >
            <v-text-field
              outlined
              dense
              label="Manager Name"
              v-model="currentManager.ManagerName"
              :readonly="!isEditMode"
              :rules="[rules.required]"
              class="formInput"
            >
            </v-text-field>
            <v-text-field
              outlined
              dense
              label="Telephone"
              v-model="currentManager.ManagerPhone"
              :readonly="!isEditMode"
              class="formInput"
            >
            </v-text-field>
            <v-text-field
              outlined
              dense
              label="Email"
              v-model="currentManager.ManagerEmail"
              :readonly="!isEditMode"
              class="formInput"
            >
            </v-text-field>
          </v-form>
          <div v-if="showFormButtons" class="formFooter">
            <div class="btnContainer">
              <v-btn
                v-if="!isEditMode && isSelectedManagerExists"
                outlined
                color="error"
                @click="onDelete"
                >Delete</v-btn
              >
              <v-spacer></v-spacer>
              <v-btn v-if="!isEditMode" outlined color="primary" @click="onEdit">Edit</v-btn>
              <v-btn v-if="isEditMode" outlined color="primary" @click="onCancel">Cancel</v-btn>
              <v-btn
                v-if="isEditMode"
                depressed
                color="primary"
                @click="saveChanges"
                class="ml-4"
                :disabled="!isFormValid"
                >Save</v-btn
              >
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
    <Dialog ref="messageBox"></Dialog>
  </div>
</template>

<script>
import Dialog from '@/components/layout/Dialog.vue';

export default {
  name: 'Managers',
  components: {
    Dialog,
  },
  data() {
    return {
      isEditMode: false,
      isFormValid: false,
      dialog: false,
      managerList: [],
      currentManager: null,
      headers: [
        { text: 'Name', value: 'ManagerName' },
        { text: 'Telephone', value: 'ManagerPhone' },
        { text: 'Email', value: 'ManagerEmail' },
      ],
      rules: {
        required: (value) => !!value || 'Required.',
      },
      selectedManager: [],
    };
  },
  mounted: function () {
    this.getManagerList();
    this.$root.currentPage = 'Investment';
  },
  destroyed() {
    this.$root.currentPage = null;
  },
  computed: {
    currentPlanId() {
      return this.$store.getters.currentPlanId;
    },
    showFormButtons() {
      const userPermission = this.$store.getters.getUserPermission(this.$route.path);
      if (userPermission && userPermission == 'Full') return true;

      return false;
    },
    isSelectedManagerExists() {
      return this.selectedManager && this.selectedManager.length > 0;
    },
  },
  watch: {},
  methods: {
    selectManager(item, row) {
      row.select(true);
      this.getManager(item.ManagerName);
    },
    onAddNewManager() {
      this.currentManager = {
        ManagerId: 0,
        ManagerName: null,
        ManagerPhone: null,
        ManagerEmail: null,
      };
      this.selectedManager = [];
      this.isEditMode = true;
    },
    onEdit() {
      this.isEditMode = true;
    },
    onCancel() {
      this.isEditMode = false;
      if (this.isSelectedManagerExists) this.getManager(this.selectedManager[0].ManagerName);
      else this.selectedManager = [];
    },
    onDelete() {
      this.deleteManager();
    },
    saveChanges() {
      const isFormValid = this.$refs.managerForm.validate();
      if (isFormValid) {
        this.updateManager();
      }
    },

    async getManager(name) {
      try {
        let response = await this.$api.get('/funds/getmanagerbyname', { params: { name: name } });

        if (!response.data) {
          const msg = 'Unable to load manager ' + name;
          this.$store.commit('setNotificationMessage', { type: 'error', text: msg });
          throw new Error(msg);
        }
        this.currentManager = response.data;
        this.isEditMode = false;
      } catch (err) {
        console.error(err);
      }
    },
    async getManagerList(managerId) {
      try {
        let response = await this.$api.get('/funds/getManagerList');
        var data = response.data;
        this.managerList = data;
        if (this.managerList && this.managerList.length) {
          if (managerId) {
            const selected = this.managerList.find((x) => x.ManagerId == managerId);
            if (selected) this.selectedManager = [selected];
            this.getManager(selected.ManagerName);
          } else {
            const manager = this.managerList[0];
            this.getManager(manager.ManagerName);
            this.selectedManager = [manager];
          }
        }
        this.isEditMode = false;
      } catch (err) {
        console.error(err);
      }
    },
    async updateManager() {
      try {
        const response = await this.$api.post('/funds/updateManager', this.currentManager);
        if (response.data) {
          const managerId = this.currentManager.ManagerId
            ? this.currentManager.ManagerId
            : response.data.Value;
          this.getManagerList(managerId);
        }
      } catch (err) {
        console.error(err);
      }
    },
    async deleteManager() {
      try {
        await this.$refs.messageBox.open(
          'Confirmation',
          'Are you sure you wish to delete this record ?'
        );

        await this.$api.delete('/funds/deleteManager?id=' + this.currentManager.ManagerId);
        this.isEditMode = false;
        this.selectedManager = [];
        this.getManagerList();
      } catch (err) {
        console.error(err);
      }
    },
  },
};
</script>
<style scoped>
.managers {
  margin-top: 5px;
  margin-bottom: 10px;
  padding: 5px 20px;
}

.managers .areaTitle {
  display: flex;
  justify-content: space-between;
  margin-bottom: 5px;
}

.managers .formContainer .managerForm {
  max-height: 700px;
  overflow-y: auto;
  padding-right: 10px;
  padding-top: 10px;
}

/* .managers .formContainer .managerForm .formInput {
  margin-bottom: 15px;
} */
</style>

<style lang="scss" scoped>
.formContainer {
  position: relative;
  height: 100%;

  .formFooter {
    bottom: 0;
    width: 100%;
    margin-top: 5px;

    position: sticky;
    background-color: white;
    padding: 8px 0 0 0;
    border-top: 1px solid rgba(0, 0, 0, 0.12);

    .btnContainer {
      display: flex;
    }
  }
}
</style>
